export default "__VITE_ASSET__Budw5mZn__"